import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a7f016e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "review" }
const _hoisted_2 = { class: "information" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "blue" }),
  /*#__PURE__*/_createElementVNode("p", null, "企业信息:")
], -1))
const _hoisted_4 = { class: "name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "公司名称:", -1))
const _hoisted_6 = { class: "firmname" }
const _hoisted_7 = { class: "location" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "公司地址:", -1))
const _hoisted_9 = { class: "product" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "主营产品:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "photo" }, [
  /*#__PURE__*/_createElementVNode("p", null, "证件照片:"),
  /*#__PURE__*/_createElementVNode("div", null, "已上传")
], -1))
const _hoisted_12 = { class: "contact" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "blue" }),
  /*#__PURE__*/_createElementVNode("p", null, "联系方式")
], -1))
const _hoisted_14 = { class: "username" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "姓名:", -1))
const _hoisted_16 = { class: "phone" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "手机号:", -1))
const _hoisted_18 = { class: "tel" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "公司电话:", -1))
const _hoisted_20 = { class: "warn" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "!", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.getInformation.data.company), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", null, _toDisplayString(_ctx.getInformation.data.address), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", null, _toDisplayString(_ctx.getInformation.data.products), 1)
      ]),
      _hoisted_11
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", null, _toDisplayString(_ctx.getInformation.data.name), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _createElementVNode("div", null, _toDisplayString(_ctx.getInformation.data.mobile), 1)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", null, _toDisplayString(_ctx.getInformation.data.office_num), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("p", null, _toDisplayString(_ctx.getInformation.data.reason), 1)
    ]),
    _createElementVNode("button", {
      class: "routine submit",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goback && _ctx.goback(...args)))
    }, "修改")
  ]))
}